export function displayField(itemId, list) {
  if (!itemId || !list) {
    return false;
  }
  return list.includes(itemId);
}
